import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#454545",
      class: "background",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.706 18.997v6.018c0 .453.388.906.906.906h3.623v-7.765h-3.623c-.453 0-.906.389-.906.906v-.065ZM24.588 12.332c0-.582-.647-.905-1.1-.517l-8.541 6.34v7.766l4.335 3.17 4.206 3.106c.453.388 1.1 0 1.1-.518V12.332ZM31.059 14.207 29.7 15.565a9.045 9.045 0 0 1 2.653 6.406 9.045 9.045 0 0 1-2.653 6.406l1.359 1.36c2.006-2.007 3.235-4.724 3.235-7.766 0-3.04-1.23-5.758-3.235-7.764ZM27.435 17.83l-1.359 1.36c.712.711 1.165 1.682 1.165 2.717 0 1.035-.453 2.07-1.165 2.718l1.36 1.358c1.035-1.035 1.682-2.523 1.682-4.14 0-1.618-.647-3.042-1.683-4.142v.13Z",
      class: "foreground"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m29.247 16.019-1.359 1.359c1.165 1.165 1.877 2.782 1.877 4.594 0 1.812-.712 3.43-1.877 4.594l1.359 1.359a8.308 8.308 0 0 0 2.459-5.953c0-2.33-.97-4.4-2.459-5.953Z",
      class: "foreground"
    }, null, -1)
  ])))
}
export default { render: render }